import React from "react";
import { useLocation } from "react-router-dom";
import forEach from "lodash.foreach";

import Log, { LogContext } from "./LogContainer";
import activity from "../activity/activityLogger";
import { asyncSessionStorageSet } from "../activity/common";
import { SHOULD_LOG_ACTIVITY } from "../constants";

function getEventHandlers(child, consumedProps, actionProps) {
  const eventHandlers = {};

  forEach(actionProps, (specificHandlerProps, eventHandlerName) => {
    eventHandlers[eventHandlerName] = (...eventHandlerArgs) => {
      child.props[eventHandlerName]?.apply(child, eventHandlerArgs);

      // Log activity of this component only if these prop are true
      if (SHOULD_LOG_ACTIVITY && consumedProps["logImpression"]) {
        delete consumedProps["logImpression"];
        activity.log([
          {
            ...consumedProps,
            ...specificHandlerProps,
            timeStamp: new Date().getTime(),
          },
        ]);
        asyncSessionStorageSet("previousActivity", {
          ...consumedProps,
          ...specificHandlerProps,
          timeStamp: new Date().getTime(),
        });
      }
    };
  });

  return eventHandlers;
}

export default function LogEvent(props) {
  const { elementType, actionProps, logEventProps, children, logImpression } =
    props;

  const { pathname, search } = useLocation();

  if (!logEventProps || !actionProps) {
    return children;
  }

  return (
    <Log elementType={elementType} {...logEventProps}>
      <LogContext.Consumer>
        {(consumedProps) =>
          React.Children.map(children, (child) =>
            React.cloneElement(
              child,
              getEventHandlers(
                child,
                {
                  ...consumedProps,
                  logImpression,
                  page: pathname,
                  queryString: search,
                },
                actionProps
              )
            )
          )
        }
      </LogContext.Consumer>
    </Log>
  );
}
